import React from "react";
import { NavLink } from "react-router-dom";
import styles from "../styles/AdminLayout.module.css";
import { ADMIN_NAV_GROUPS } from "../navigation";

function joinClasses(...values) {
  return values.filter(Boolean).join(" ");
}

export function AdminSidebar({ open, onClose }) {
  return (
    <>
      <button
        type="button"
        aria-label="Закрыть навигацию"
        className={joinClasses(styles.sidebarOverlay, open && styles.sidebarOverlayVisible)}
        onClick={onClose}
      />

      <aside className={joinClasses(styles.sidebar, open && styles.sidebarOpen)}>
        <div className={styles.sidebarHeader}>
          <div className={styles.sidebarEyebrow}>Рабочая зона</div>
          <div className={styles.sidebarTitle}>Панель управления</div>
        </div>

        <div className={styles.sidebarBody}>
          {ADMIN_NAV_GROUPS.map((group) => (
            <section key={group.id} className={styles.sidebarGroup}>
              <div className={styles.sidebarGroupTitle}>{group.label}</div>
              <nav className={styles.sidebarNav}>
                {group.items.map((item) => (
                  <NavLink
                    key={item.id}
                    to={item.to}
                    className={({ isActive }) =>
                      joinClasses(styles.sidebarLink, isActive && styles.sidebarLinkActive)
                    }
                    onClick={onClose}
                  >
                    <span className={styles.sidebarLinkLabel}>{item.label}</span>
                    <span className={styles.sidebarLinkDescription}>{item.description}</span>
                  </NavLink>
                ))}
              </nav>
            </section>
          ))}
        </div>
      </aside>
    </>
  );
}

export default AdminSidebar;
